import { PUBLIC_URL, getDomainConfig } from "./main";

export const RETARGEO_IP_LEGAL_ENTITY_SINCE = new Date(2026, 7, 29);

// Клиенты на старом юрлице ООО (счёт + оферта/документы)
export const RETARGEO_FORCE_OOO_USER_IDS = new Set([
  "1e91f1e7-6c35-4bc0-b51f-ac487599002a",
]);

export const RETARGEO_DOC_FILES = {
  oferta: "publichnyj_dogovor-oferta.pdf",
  privacy: "politika_konfidencialnosti.pdf",
  siteRules: "pravila_polzovaniya_sajtom.pdf",
  adsRules: "pravila_razmeshcheniya_reklamnyh_obyavlenij.pdf",
};

export function shouldUseRetargeoIpDocs(user) {
  if (getDomainConfig().brand !== "retargeo") {
    return false;
  }
  if (user?.id && RETARGEO_FORCE_OOO_USER_IDS.has(String(user.id))) {
    return false;
  }
  if (user && typeof user.use_ip_legal_entity === "boolean") {
    return user.use_ip_legal_entity;
  }
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today >= RETARGEO_IP_LEGAL_ENTITY_SINCE;
}

export function getRetargeoDocUrl(filename, user) {
  const useIp = shouldUseRetargeoIpDocs(user);
  const folder = useIp ? "retargeo_docs" : "retargeo_docs/ooo";
  const base = PUBLIC_URL || "";
  return `${base}/${folder}/${filename}`;
}
